export default __webpack_public_path__ + "static/media/Grupo6141.db3c2257.svg";